/**
 * A validator for leaflets LatLng to be used with React prop types
 */
import * as L from 'leaflet';
import createInstanceValidator from '../utils/createInstanceValidator';

export default { ...createInstanceValidator(L.LatLng, 'LatLng') };